import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../components/Forms/FormCreator";
import Accordion from "../../../../components/Accordion/Accordion";
import { CompanyDetailsFormData } from "./CompanyDetails.data";
import Buttons from "../../../../components/ui/button/Buttons";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../utils/Encryption";
import SwalAlert from "../../../../services/swalService/SwalService";
import { useUpdateCompanyDetailAndOtherInformationMutation } from "../../../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import { applyProductServiceInitialState, handleConditionBaseFields, includesValueNormalized, toggleFieldVisibilityWithLabel } from "./Utils/CompanyDetailsUtils";
import { filterDropDownList } from "./Utils/DropdownUtils";

const CompanyDetailsForm = (props) => {
  const companyDetailsRef = useRef();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const triggerMap = { 12: "Others; Please specify", 18: "Others; Please specify", 38: "Others; Please specify" };
  const [formData, setFormData] = useState(CompanyDetailsFormData);
  const { error, success } = SwalAlert();
  const [updateCompanyDetail, { isSuccess: isUpdateCompanyDetail, isLoading: isUpdateCompanyDetailLoading, data: updateCompanyDetailData }] = useUpdateCompanyDetailAndOtherInformationMutation();

  useEffect(() => {
    if (!isUpdateCompanyDetailLoading && isUpdateCompanyDetail && updateCompanyDetailData) {
      if (updateCompanyDetailData?.keyId > 0) {
        success( "Application Saved successfully." )
        props?.onCompanyUpdated();
      }
    }
  }, [isUpdateCompanyDetailLoading, isUpdateCompanyDetail, updateCompanyDetailData]);

  const handleSave = () => {
    const data = companyDetailsRef?.current?.getFormData();
    if (!data) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }

    let request = {
      SGBCCorporateMemberId: editID,
      RegisteredCompanyName: data?.registeredCompanyName || null,
      CompanyUEN: data?.uENNumber || null,
      TypeOfCompany: data?.typeofCompany?.value || data?.typeofCompany || null,
      OrganisationProfileId: data?.organisationProfile?.value || data?.organisationProfile || null,
      BusinessCategoriesId: data?.businessCategories?.value || data?.businessCategories || null,
      OrganisationCategory: data?.organisationCategory?.value || data?.organisationCategory,
      OtherOrganisationCategory: null,
      ProductsAndServiceByOrganisationId: data?.productsandServicesOfferedbyOrganisation?.length > 0 ? data?.productsandServicesOfferedbyOrganisation?.join(',') : null,
      OtherProductsandServices: data?.otherproductsandServices || null,
      TypeOfProduct: data?.typeOfProduct || null,
      DescribeTheWays: data?.describeTheWays || null,
      CompanyDescription: data?.companyDescription || null,
      IsPSPCListedOrg: data?.areyouaPSPCListedOrganisation === "yes" ? true : false,
      PSPCListingCodeId: data?.pspcListedOrganisation?.length > 0 ? data?.pspcListedOrganisation?.join(',') : null,
      Howdidyoulearnaboutsgbc: data?.howdidyoulearnaboutsgbc?.length > 0 ? data?.howdidyoulearnaboutsgbc?.join(',') : null,
      OtherInformationAboutSGBC: data?.otherInformationAboutSGBC || null,
      Anyotherinformationtobeprovidedtosgbc: data?.anyotherinformationtobeprovidedtosgbc || null,
      ReasonforjoiningSGBCCorporateMembership: data?.reasonforjoiningSGBCCorporateMembership?.length > 0 ? data?.reasonforjoiningSGBCCorporateMembership?.join(',') : null,
      OtherReasonOfJoining: data?.otherReasonOfJoining || null,
    };
    updateCompanyDetail(request);
  }

  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    if (dataField == "howdidyoulearnaboutsgbc" || dataField == "reasonforjoiningSGBCCorporateMembership") {
      const selectedValue = value?.value ?? value;
      let nextFormDataBase = { ...formData, initialState: { ...formData.initialState, [dataField]: selectedValue } };
      if (dataField == "howdidyoulearnaboutsgbc") {
        let updated = handleConditionBaseFields(selectedValue, nextFormDataBase, "otherInformationAboutSGBC", [5, 4]);
        if (!includesValueNormalized(selectedValue, 5) && !includesValueNormalized(selectedValue, 4)) {
          updated = { ...updated, initialState: { ...updated.initialState, otherInformationAboutSGBC: null } };
        }
        setFormData(updated);
        return;
      }
      if (dataField === "reasonforjoiningSGBCCorporateMembership") {
        let updated = handleConditionBaseFields(selectedValue, nextFormDataBase, "otherReasonOfJoining", [8]);
        if (!includesValueNormalized(selectedValue, 8)) {
          updated = { ...updated, initialState: { ...updated.initialState, otherReasonOfJoining: null } };
        }
        setFormData(updated);
        return;
      }
      setFormData(nextFormDataBase);
    }
    else if (dataField === "organisationCategory") {
      const selectedValue = value?.value ?? null;
      let updatedFormData = { ...form, initialState: { ...form.initialState, organisationCategory: selectedValue, productsandServicesOfferedbyOrganisation: null, otherproductsandServices: null, } }; const updatedProductServiceOptions = props?.dropDownList ? filterDropDownList(`org${selectedValue}`, props?.dropDownList) : [];
      updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "productsandServicesOfferedbyOrganisation" ? { ...field, fieldSetting: { ...field.fieldSetting, options: updatedProductServiceOptions, }, } : field), };
      updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "otherproductsandServices" ? { ...field, validation: [], style: { ...field.style, containerCss: "col-md-5 mb-3", }, fieldSetting: { ...field.fieldSetting, isDisable: true, } } : field), };
      setFormData(updatedFormData);
    }
     else if (dataField === "productsandServicesOfferedbyOrganisation") {
          const selectedValue = value ?? null;
          let updatedFormData = {...form,initialState: {...form.initialState,productsandServicesOfferedbyOrganisation: selectedValue,},};
          updatedFormData = toggleFieldVisibilityWithLabel(updatedFormData, { dataFieldValue: selectedValue, triggerMap, targetFieldId: "otherproductsandServices" });
          setFormData(updatedFormData);
          return;
        }
    else if (dataField == "areyouaPSPCListedOrganisation") {
      let updatedFormData = {
        ...form, initialState: {
          ...form.initialState, areyouaPSPCListedOrganisation: value,
          pspcListedOrganisation: value === "yes" ? form.initialState.pspcListedOrganisation : ""
        },
        formFields: form.formFields.map((field) => {
          if (field.id === "pspcListedOrganisation") {
            return {
              ...field, style: { containerCss: value === "yes" ? "col-lg-5 mb-2 no-star" : "col-lg-5 mb-2 no-star d-none" },
              validation: value === "yes" ? [{ type: "require" }] : []
            };
          }
          return field;
        })
      };

      setFormData(updatedFormData);
      return;
    } else {
      // update field value safely
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  }

  useEffect(() => {
    setTimeout(() => {
      const formData = { ...CompanyDetailsFormData };
      const orgCategory = companyDetailsRef?.current?.getFieldValue("organisationCategory");
      const productsAndServices = companyDetailsRef?.current?.getFieldValue("productsandServicesOfferedbyOrganisation");
      const learnAbtSGBC = companyDetailsRef?.current?.getFieldValue("howdidyoulearnaboutsgbc");
      const pspcListed = companyDetailsRef?.current?.getFieldValue("areyouaPSPCListedOrganisation");
      const reasonForJoin = companyDetailsRef?.current?.getFieldValue("reasonforjoiningSGBCCorporateMembership");

      const shouldEnableOtherInfo = [5, 4].some(num => learnAbtSGBC?.includes(num))
      const shouldEnableReasonInfo = [8].some(num => reasonForJoin?.includes(num));
      const shouldPspcListed = pspcListed == "yes";

      const serviceOptions = filterDropDownList(`org${orgCategory}`, props.dropDownList);
      let updatedFormData = { ...formData, formFields: formData.formFields.map(field => field.id === "productsandServicesOfferedbyOrganisation" ? { ...field, fieldSetting: { ...field.fieldSetting, options: serviceOptions } } : field) };
      updatedFormData = applyProductServiceInitialState({ formData, dropdownData: props.dropDownList, orgCategory, productsAndServices, isRenewal:props.isRenewalCheck});
      //  new setformdata 
      
     
      
      if (!shouldEnableOtherInfo && !shouldEnableReasonInfo && !shouldPspcListed) {
        setFormData(updatedFormData);
        return;
      };

      let updatedFormFields = updatedFormData.formFields.map((field) => {
        // Enable "otherInformationAboutSGBC" field
        if (shouldEnableOtherInfo && field.id === "otherInformationAboutSGBC") {
          return {
            ...field,
            style: { containerCss: "col-md-5 mb-2" },
            validation: [{ type: "require" }],
          };
        }
        // Enable "otherReasonOfJoining" field
        if (shouldEnableReasonInfo && field.id === "otherReasonOfJoining") {
          return {
            ...field,
            style: { containerCss: "col-md-5 mb-2" },
            validation: [{ type: "require" }],
          };
        }
        // Enable "areyouaPSPCListedOrganisation" field
        if (shouldPspcListed && field.id === "pspcListedOrganisation") {
          return {
            ...field,
            style: { containerCss: "col-lg-5 mb-2 no-star" },
            validation: [{ type: "require" }],
          };
        }
        return field;
      });
      setFormData({ ...updatedFormData, formFields: updatedFormFields });
    }, 0);
  }, [props.dropDownList]);

  const handleClickToCorporate = () => {
    window.open(`/viewCorporateMember/${id}`);
  }

  return (
    <Accordion
      title="Company Details"
      buttonLabel="View Corporate Information"
      accordion={false}
      clickEvent={handleClickToCorporate}
      isDisable={props?.isAppLocked}
    >
      <div className="row">
        <FormCreator
          ref={companyDetailsRef}
          {...formData}
          onFormFieldValueChange={handleFormFieldChange}
        />
      </div>
      <div className="btn-right-side">
        <Buttons
          buttonText="Save"
          buttonTypeClassName="success-btn"
          onClick={handleSave}
          isLoading={isUpdateCompanyDetailLoading}
          isDisable={isUpdateCompanyDetailLoading || props?.isViewOnly || props?.isAppLocked}

        />
      </div>
    </Accordion>
  );
};
export default CompanyDetailsForm;
